"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import * as React from "react";
import { cn } from "../lib";
import { CIRCULAR_FIELD_OUTER_SHELL_CLASS } from "../lib/circular-field-control-styles";
import {
	CircularFieldControlWell,
	CircularFieldExpDisk,
} from "./circular-field-control";

/**
 * Circular marketing-style checkbox: subtle outer rim (`border-black/15`, matches landing logo-strip
 * light top hairline), recessed inner well, EXP green gradient fill when checked (completion-overlay palette).
 */
const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn("group", CIRCULAR_FIELD_OUTER_SHELL_CLASS, className)}
		{...props}
	>
		<CircularFieldControlWell relative>
			<CheckboxPrimitive.Indicator className="flex items-center justify-center">
				<CircularFieldExpDisk>
					<Check className="size-2.5 text-white" strokeWidth={3} />
				</CircularFieldExpDisk>
			</CheckboxPrimitive.Indicator>
			<span className="pointer-events-none absolute inset-0 hidden items-center justify-center group-data-[state=indeterminate]:flex">
				<CircularFieldExpDisk>
					<Minus className="size-2.5 text-white" strokeWidth={3} />
				</CircularFieldExpDisk>
			</span>
		</CircularFieldControlWell>
	</CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
